import Request from 'superagent';

/**
 * Exposes an interface for communicating with TTL Core-API Backend
 */
export default class TTLProxy{

    //  The API-Key
    apiKey;

    //  The server address
    serverAddress;

    /**
     * Builds an absolute uri to be sent directly to the server
     * @param url
     * @returns {string}
     */
    getUrl(url){

        if(url[0] == '/')
            url = url.substr(1);

        return `${this.serverAddress}/${url}`;
    }

    constructor(apiKey,address , credentials ) {

        //  set api-key
        this.apiKey = apiKey;

        //  set server address
        this.serverAddress = address;

        //
        if(!this.isAuthenticated())
            this.initProxy(credentials);
    }

    setAuthInfo(token , user , refreshToken ){

        let authInfo = {
            token: token,
            user: user,
            refreshToken: refreshToken
        };

        //  save session info
        window.sessionStorage.setItem('auth_info', JSON.stringify(authInfo) );

        // overwrite reference
        this._authInfo = authInfo;
    }

    getAuthInfo(){

        //  check instance reference
        if(this._authInfo){
            return this._authInfo;
        }

        let authInfo = window.sessionStorage.getItem('auth_info');
        if(authInfo){
            return JSON.parse(authInfo);
        }

        return null;
    }

    /**
     * Checks whether the proxy is authenticated and ready for communication
     */
    isAuthenticated(){
        return this.getAuthInfo() != null;
    }

    /**
     * Initialize proxy with credentials supplied
     * @param credentials
     */
    initProxy(credentials){

        const me = this;
        return this.processRequest('/auth/local',{
            method: 'post',
            content: credentials,
            noAuth: true
        }).then((response) =>{

            let authInfo = response.body;

            //  set authentication info
            me.setAuthInfo(authInfo.token , authInfo.user , authInfo.refreshToken );

        }).catch((err) =>{
            console.log('Failed authenticating proxy client')
        });
    }

    /**
     * Registers a new farmer with supplied properties
     * Properties: name , acres , farm location , phone , sex , email , source , fbo
     * @param properties
     */
    createFarmer(properties){

       return this.processRequest('/api/farmers',{
            method: 'post',
            content: {
                name: properties.name,
                acres: properties.acres || undefined,
                farm_location:  properties.farm_location || '',
                farm_location_lat: properties.farm_location_lat || 0,
                farm_location_long: properties.farm_location_long || 0,
                sex: properties.sex,
                source : properties.source || 1,
                email: properties.email,
                phone: properties.phone
            }
        });
    }

    /**
     * Registers a tractor owner
     * Properties: username, password , email, phone , first name , last name, type , location
     * @param properties
     */
    registerTractorOwner(properties){

        return this.processRequest('/api/users/owner',{
            method: 'post',
            content: {
                username: properties.username,
                password: undefined,
                phone: properties.phone,
                type: properties.type,
                email: properties.email,
                owner:{
                    name: properties.name,
                    location: properties.location,
                    location_lat: properties.location_lat,
                    location_long: properties.location_long
                }
            }
        });
    }

    /**
     * Registers a FBO
     * Properties: username, password , email, phone , name, location
     * @param properties
     */
    registerFBO(properties){

        return this.processRequest('/api/users/fbo',{
            method: 'post',
            content:{
                username: properties.username,
                password: properties.password,
                email: properties.email,
                phone: properties.phone,
                fbo:{
                    name: properties.name,
                    location: properties.location,
                    location_lat : properties.location_lat,
                    location_long: properties.location_long
                }
            }
        });
    }


    /**
     * Returns the payload of server response
     * @param response
     * @returns {any}
     */
    getResponseData(response){

        let body = response.body;
        alert(JSON.stringify(body));
        if(body.status === 0){

            //  we're certain the response has valid data
            return response.body.payload.data;
        }

        return  null;
    }

    /**
     * Returns the total count of records from server response
     * @param response
     * @returns {null}
     */
    getResponseCount(response){
        let body = response.body;
        if(body.status === 0){

            //  we're certain the response has valid data
            return response.body.payload.count;
        }

        return  null;
    }

    getResponseMessage(response){

        //  Created response
        if(response.status == 201){

        }

        //  Update response
    }

    processRequest(url,opts){

        const me = this;
        if(!opts.noAuth){
            if(!this.isAuthenticated()){
                console.log('Not authenticated')
                return;
            }
        }

        return new Promise((resolve,reject) => {

            let reqChain = Request[opts.method || "post" ](me.getUrl(url));

            if(me.apiKey){
                reqChain.set('x-api-key',me.apiKey);
            }

            if(!opts.noAuth) {
                let authInfo = me.getAuthInfo();
                if (authInfo) {
                    reqChain.set('Authorization','Bearer ' + authInfo.token);
                }
            }

            //  set headers
            let headers = opts.headers;
            if(headers) {
                for (let item in headers) {
                    if (headers.hasOwnProperty(item))
                        reqChain.set(item, headers[item]);
                }
            }

            //  set query parameters
            let query = opts.query;
            if(query) {
                for (let item in query) {
                    if(query.hasOwnProperty(item))
                        reqChain.query(item,query[item]);
                }
            }

            //  set content
            if(opts.content){
                reqChain.send(opts.content);
            }

            //  send request
            reqChain.end(function (err, response) {

                if(err){

                    //  Determines whether the error is a network error
                    err.isConnectionError = () =>{
                        return !err.status || !err.response;
                    };

                    //  Determine whether request was sent but got error response
                    err.isServerError = () => {
                        return !!err.status;
                    };

                    //  Returns the error of message in the response
                    err.getServerError = () =>{

                        //  check for error response
                        if(err.isServerError() && response.body.status != 0){
                            return response.body.error.message;
                        }

                        return null;
                    };

                    return reject(err);
                }

                //
                if(response){

                    //  Get actual data
                    response.getPayload = () =>{
                        return me.getResponseData(response);
                    };

                    //  Get count
                    response.getPayloadCount = () =>{
                        return me.getResponseCount(response);
                    };

                    //  Get operation status message
                    response.getOperationMessage = () =>{
                        return me.getResponseMessage(response);
                    };

                }

                return resolve( response );

            });

        });
    }
}


// WEBPACK FOOTER //
// ./src/Common/TTLProxy.js